// extracted by mini-css-extract-plugin
var _1 = "DetailProduct_brandName__ZANk0";
var _2 = "DetailProduct_btnProductsDetail__snMCu";
var _3 = "DetailProduct_buttonWrapper__Nsx3C";
var _4 = "DetailProduct_buttons__lpg+C";
var _5 = "DetailProduct_container__QGfsa";
var _6 = "DetailProduct_data__JCurr";
var _7 = "DetailProduct_description__j7tZZ";
var _8 = "DetailProduct_detailProduct__K3hpF";
var _9 = "DetailProduct_hasSaveChangeButton__b4zPj";
var _a = "DetailProduct_image__l-1nV";
var _b = "DetailProduct_imageContainer__Lg2yZ";
var _c = "DetailProduct_quantity__vrglC";
var _d = "DetailProduct_replacementTag__EZvrt";
var _e = "DetailProduct_saveChangesButton__4-k3s";
var _f = "DetailProduct_sizeInfo__qubPa";
var _10 = "DetailProduct_status__XPq6+";
var _11 = "DetailProduct_subscriptionContainer__KV+kV";
var _12 = "DetailProduct_title__2vkBg";
var _13 = "DetailProduct_unavailable__Z-olt";
export { _1 as "brandName", _2 as "btnProductsDetail", _3 as "buttonWrapper", _4 as "buttons", _5 as "container", _6 as "data", _7 as "description", _8 as "detailProduct", _9 as "hasSaveChangeButton", _a as "image", _b as "imageContainer", _c as "quantity", _d as "replacementTag", _e as "saveChangesButton", _f as "sizeInfo", _10 as "status", _11 as "subscriptionContainer", _12 as "title", _13 as "unavailable" }
